import { onJQueryTriggeredChange } from "#/admin/legacy/jquery-change-bridge.js";
import { onDocumentReady } from "#/admin/legacy/forms/document-ready.js";
import { disableInputs, enableInputs, findInputs } from "#/admin/legacy/forms/input-ownership.js";
import { findTargets } from "#/admin/legacy/forms/target-lookup.js";
import { setTargetVisibility } from "#/admin/legacy/forms/target-visibility.js";

const SELECTOR = '[data-behaviour~="show-target-on-checked"]';

function updateTargets(control, selector, scope, visible) {
  for (const target of findTargets(control, selector, scope)) {
    setTargetVisibility(target, visible);

    if (visible) {
      enableInputs(findInputs(target), control);
    } else {
      disableInputs(findInputs(target), control);
    }
  }
}

function updateCheckedTargets(control) {
  updateTargets(control, control.dataset.showTarget, control.dataset.showTargetContainer, control.checked);
  updateTargets(
    control,
    control.dataset.disabledStateTarget,
    control.dataset.disabledStateTargetContainer,
    !control.checked,
  );
}

function handleCheckedChange(event) {
  const control = event.target.closest(SELECTOR);

  if (control) {
    updateCheckedTargets(control);
  }
}

document.addEventListener("change", handleCheckedChange);
document.addEventListener("input", handleCheckedChange);

onJQueryTriggeredChange(handleCheckedChange);
onDocumentReady(function initializeCheckedTargets() {
  document.querySelectorAll(SELECTOR).forEach(updateCheckedTargets);
});
